import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ActionIcon, Flex } from "@mantine/core";
import { Delete, Edit, EmailOutlined } from "@mui/icons-material";
import { SvgIcon } from "@mui/material";
import { createSingleLinePreview } from "../../utils/String.utils";
export const SimpleEmailTemplateRow = ({ simpleEmailTemplate, onClickEdit, onClickDelete }) => {
    return (_jsxs("div", { className: "hover-opacity-parent", style: {
            backgroundColor: "var(--mantine-color-primary-3)",
            display: "grid",
            gridTemplateColumns: "auto 1fr auto",
            alignItems: "center",
            gap: "0.5rem",
            width: "100%",
            borderRadius: "0.2rem",
            minHeight: "2rem"
        }, children: [_jsx(SvgIcon, { component: EmailOutlined, style: {
                    fontSize: "1rem",
                    color: "grey",
                    marginLeft: "0.5rem"
                } }), _jsxs(Flex, { style: {
                    gap: "0.5rem",
                    minWidth: 0,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                }, children: [_jsx("span", { style: {
                            fontWeight: 700,
                            fontSize: "var(--mantine-font-size-xs)",
                            flexShrink: 0
                        }, children: simpleEmailTemplate.subject }), _jsx("span", { style: {
                            color: "var(--mantine-color-dimmed)",
                            fontSize: "var(--mantine-font-size-xs)",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        }, children: `- ${createSingleLinePreview(simpleEmailTemplate.body)}` })] }), _jsxs(Flex, { children: [_jsx(ActionIcon, { className: "hover-opacity", variant: "transparent", onClick: () => onClickEdit(simpleEmailTemplate), children: _jsx(SvgIcon, { component: Edit, style: { fontSize: "1rem", color: "grey" } }) }), _jsx(ActionIcon, { className: "hover-opacity", variant: "transparent", onClick: () => onClickDelete(simpleEmailTemplate), children: _jsx(SvgIcon, { component: Delete, style: { fontSize: "1rem", color: "grey" } }) })] })] }));
};
